import * as React from 'react';
import { IPropsBasic, } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import { create } from 'kts-scaffold-framework/utils/form';
import moment from 'moment';
import { invoiceImport } from 'src/api';
import { getSwjg, adm, alxd } from 'kts-platform-frame/display/part/InvoiceImport/InvoiceTab/VerifyInvoice';
import ReduxState from 'kts-platform-frame/redux/ReduxState';
import { authManage } from 'src/api';
import { message, Row, Col, Form, Input, Button, Card, Icon, Checkbox } from 'antd';
import { Field } from 'kts-scaffold-framework/utils/doc';
const FormItem = Form.Item;
const ButtonGroup = Button.Group;
const css = require('./index.scss');
/** Redux接口 */
interface IReduxStatePart {

}
/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}
@create()
/** 发票录入 */
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class AddRest extends React.Component<IProps, any> {
    private input1: Input;
    private input2: Input;
    private input3: Input;
    private input4: Input;
    private input5: Input;
    constructor(props: IProps) {
        super(props);
        this.state = {
            inputId: this.props.match.params.entryLogId,
            list: this.props.location.state,
            data: null,
            image: null,
            tip: '开具金额(不含税)',
            showCheck: false,
            available: false,
            decodeState: true,
            originFileUrl: null,
            fileName: null,
            draftFlag: 0,
            currentIndex: 0,
        };
    }

    componentDidMount() {
        this.getData();
        let { list, inputId } = this.state;
        let currentIndex = list.indexOf(inputId);
        this.setState({
            currentIndex
        });
    }
    onPrevious = () => {
        let { currentIndex, list } = this.state;
        currentIndex--;
        if (currentIndex < 0) {
            currentIndex = 0;
        }else{
            this.setState({
                inputId: list[currentIndex],
                currentIndex
            }, () => { this.getData(); });
        }
        
    }
    onNext = () => {
        let { currentIndex, list } = this.state;
        currentIndex++;
        if (currentIndex >= list.length) {
            currentIndex = list.length - 1;
        }else{
            this.setState({
                inputId: list[currentIndex],
                currentIndex
            }, () => { this.getData(); });
        }
        
    }
    getData = () => {
        authManage.addRest(this, { inputId: this.state.inputId }).then((response) => {
            const res = response.res;
            if (res) {
                this.validatorCode(res.invoiceCode);
                this.setState({
                    data: res,
                    decodeState: res.ocrState === 2 ? true : false
                });
            }

        });
        authManage.ImgQuery(this, { inputId: this.state.inputId }).then((response: any) => {
            const res = response.res;
            if (res) {
                this.setState({
                    image: res.fileUrl,
                    originFileUrl: res.fileUrl
                });
            }
        });
    }

    handleSubmit = () => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                const { inputId, draftFlag } = this.state;
                let data = {
                    ...values,
                    inputId,
                    draftFlag
                };
                this.input1.input.select();
                authManage.saveRest(this, data).then((response) => {
                    const error = response.er;
                    if (!error) {
                        this.success();
                    }
                });
            }
        });
    }
    resetForm = () => {
        const { resetFields } = this.props.form;
        resetFields();
    }
    success = () => {
        message.success('录入成功');
    }
    error = () => {
        message.error('录入失败');
    }

    onCodeChange = (rule, value, callback) => {
        //检测是否为全数字
        if (rule.pattern.test(value)) {
            if (value.length === 10 || value.length === 12) {
                let swjginfo = getSwjg(value, 0);
                if (swjginfo.length === 0) {
                    callback('发票代码有误!');
                } else {
                    if (!adm(value) || swjginfo.length === 0) {
                        callback('发票代码有误!');
                    } else {
                        let fplx = alxd(value);//fplx 发票类型 

                        if ((fplx === '01' || fplx === '02' || fplx === '03')) {
                            this.setState({
                                showCheck: false
                            });
                            if (fplx === '02') {
                                this.setState({
                                    tip: '合计金额'
                                });
                                callback('不支持货票录入');
                            } else if (fplx === '03') {
                                this.setState({
                                    tip: '不含税价'
                                });
                            } else {
                                this.setState({
                                    tip: '开具金额(不含税)'
                                });
                            }
                        } else if (fplx === '04' || fplx === '10' || fplx === '11' || fplx === '14') {
                            this.setState({
                                showCheck: true
                            });
                        }
                        if (fplx === '01' || fplx === '03' || fplx === '14') {
                            this.setState({
                                available: true
                            });
                        } else {
                            this.setState({
                                available: false
                            });
                        }
                        callback();
                    }
                }
            } else {
                callback('请输入10位或12位合法的发票代码');
            }
        } else {
            callback('发票代码只支持数字');
        }
    }
    validatorCode = (value) => {
        if (value) {
            if (value.length === 10 || value.length === 12) {
                let swjginfo = getSwjg(value, 0);
                if (swjginfo.length === 0) {
                    return false;
                } else {
                    if (!adm(value) || swjginfo.length === 0) {
                        return false;
                    } else {
                        let fplx = alxd(value);//fplx 发票类型 

                        if ((fplx === '01' || fplx === '02' || fplx === '03')) {
                            this.setState({
                                showCheck: false
                            });
                            if (fplx === '02') {
                                this.setState({
                                    tip: '合计金额'
                                });
                            } else if (fplx === '03') {
                                this.setState({
                                    tip: '不含税价'
                                });
                            } else {
                                this.setState({
                                    tip: '开具金额(不含税)'
                                });
                            }
                        } else if (fplx === '04' || fplx === '10' || fplx === '11' || fplx === '14') {
                            this.setState({
                                showCheck: true
                            });
                        }
                        if (fplx === '01' || fplx === '03' || fplx === '14') {
                            this.setState({
                                available: true
                            });
                        } else {
                            this.setState({
                                available: false
                            });
                        }
                    }
                }
            } else {
                return false;
            }
        }
    }
    onincreaseTabindex1 = (e) => {
        this.props.form.validateFieldsAndScroll(['invoiceCode'], (err, values) => {
            if (!err) {
                this.input2.focus();
            }
        });
    }
    onincreaseTabindex2 = (e) => {
        this.props.form.validateFieldsAndScroll(['invoiceCode', 'invoiceNumber'], (err, values) => {
            if (!err) {
                this.input3.focus();
                let data = {
                    invoiceCode: values.invoiceCode,
                    invoiceNumber: values.invoiceNumber
                };
                if (this.state.available) {
                    invoiceImport.invoiceFetch(this, data).then((response: any) => {
                        const err2 = response.er;
                        const res = response.res;
                        if (err2) {
                            //message.error(err2.status.description);
                            return null;
                        } else {
                            if (res.invoiceDate) {
                                if (this.state.showCheck) {
                                    this.props.form.setFieldsValue({
                                        invoiceDate: moment.unix(res.invoiceDate / 1000).format('YYYYMMDD'),
                                        invoiceParityCode: res.invoiceParityCode && res.invoiceParityCode.substr(-6, 6),
                                    });
                                } else {
                                    this.props.form.setFieldsValue({
                                        invoiceDate: moment.unix(res.invoiceDate / 1000).format('YYYYMMDD'),
                                        amountWithoutTax: res.amountWithoutTax
                                    });
                                }
                            }
                        }
                    });
                }
            }
        });

    }
    onincreaseTabindex3 = (e) => {
        if (this.state.showCheck) {
            this.input4.focus();
            this.input4.input.select();
        } else {
            this.input5.focus();
            this.input5.input.select();
        }
    }
    onincreaseTabindex4 = (e) => {
        this.handleSubmit();
    }
    onAddGroup = () => {

    }
    onOriginFile = () => {
        window.open(this.state.originFileUrl);
    }
    checkDate = (rule, value, callback) => {
        if (rule.pattern.test(value)) {
            let isValid = moment(value).isValid();
            if (isValid) {
                callback();
            } else {
                callback('格式不对');
            }
        } else {
            callback('格式不对');
        }
    }
    onChange = (e) => {
        if (e.target.checked) {
            this.setState({
                draftFlag: 1
            });
        } else {
            this.setState({
                draftFlag: 0
            });
        }
    }

    render() {
        const { image, data, decodeState, originFileUrl } = this.state;
        let formItemLayout = {
            labelCol: { span: 8 },
            wrapperCol: { span: 16 }
        };
        const extraButton = (<div>
            <ButtonGroup className='mr10'>
                <Button icon="left" onClick={this.onPrevious} />
                <Button icon="right" onClick={this.onNext} />
            </ButtonGroup>
            <Button onClick={() => { this.props.history.goBack(); }} >返回</Button>
        </div>);

        const { getFieldDecorator } = this.props.form;

        let originFileUrlName = null;
        if (originFileUrl != null) {
            const splitOriginFileUrl = originFileUrl.split("?");
            const originFileUrlCut = splitOriginFileUrl[0].split("/");
            originFileUrlName = originFileUrlCut[originFileUrlCut.length - 1];
        }

        return (
            <div className={css.modules} style={{ height: '100%' }}>
                <Card title="影像文件" extra={extraButton}>
                    <p>发票录入时间:{data && moment.unix(data.inputTime / 1000).format('YYYY-MM-DD HH:mm:ss')}</p>
                    <div style={{ display: "inline-block", verticalAlign: 'top', width: '58%', textAlign: 'center' }}>
                        {
                            image && <img src={image} style={{ maxWidth: '100%' }} />
                        }
                        {
                            !image && <img src='/img/nopicture.png' />
                        }
                    </div>

                    <div className="pull-right" style={{ maxWidth: 440, display: 'inline-block', width: '42%' }}>
                        <Form className="manual-write-style special" >
                            <Row>
                                <Col span={24}>
                                    <FormItem {...formItemLayout} label="发票代码" >
                                        {getFieldDecorator('invoiceCode', {
                                            initialValue: data && data.invoiceCode,
                                            rules: [
                                                {
                                                    required: true,
                                                    pattern: /^[0-9]*$/,
                                                    validator: this.onCodeChange
                                                }
                                            ]
                                        })(
                                            <Input disabled={decodeState} ref={(input) => { this.input1 = input; }} placeholder="10位或12位发票码" maxLength={12} onPressEnter={this.onincreaseTabindex1} />
                                        )}
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <FormItem {...formItemLayout} label="发票号码">
                                        {getFieldDecorator('invoiceNumber', {
                                            initialValue: data && data.invoiceNumber,
                                            rules: [
                                                {
                                                    required: true,
                                                    message: '请输入8位发票号码（只支持数字)',
                                                    pattern: /^\d{8}$/
                                                }
                                            ]
                                        })(<Input disabled={decodeState} ref={(input) => { this.input2 = input; }} placeholder="8位发票号码" maxLength={8} onPressEnter={this.onincreaseTabindex2} />)}
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <FormItem {...formItemLayout} label="开票日期">
                                        {getFieldDecorator('invoiceDate', {
                                            initialValue: data && data.invoiceDate && moment.unix(data.invoiceDate / 1000).format('YYYYMMDD'),
                                            rules: [{
                                                type: 'string',
                                                required: true,
                                                message: '日期格式(20170203)',
                                                validator: this.checkDate,
                                                pattern: /\d{8}/
                                            }]
                                        })(
                                            <Input disabled={decodeState} ref={(input) => { this.input3 = input; }} placeholder="日期格式(20170203)" onPressEnter={this.onincreaseTabindex3} />
                                        )}
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24} >
                                    {!this.state.showCheck && (
                                        <FormItem {...formItemLayout} label={this.state.tip}>
                                            {getFieldDecorator('amountWithoutTax', {
                                                initialValue: decodeState ? Field.formatMoney(data && data.amountWithoutTax, 2) : data && data.amountWithoutTax && data.amountWithoutTax.toFixed(2),
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: '请输入金额（小数点最多输入两位,最大长度12位数包括小数)',
                                                        pattern: /^(\-?)[1-9]+([0-9]?)+(.[0-9]{2}|.[0-9]{1})?$/
                                                    }
                                                ]
                                            })(
                                                <Input // Field.formatMoney(
                                                    disabled={decodeState}
                                                    ref={(input) => { this.input5 = input; }}
                                                    style={{ width: '100%' }}
                                                    type={decodeState ? 'text' : 'number'}
                                                    maxLength={12}
                                                    onPressEnter={this.onincreaseTabindex4}
                                                />
                                            )}
                                        </FormItem>
                                    )}

                                    {this.state.showCheck && (
                                        <FormItem {...formItemLayout} label="校验码">
                                            {getFieldDecorator('invoiceParityCode', {
                                                initialValue: data && data.verifyCode,
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: '请输入6位校验码（只支持数字)',
                                                        pattern: /^\d{6}$/
                                                    }
                                                ]
                                            })(
                                                <Input disabled={decodeState} ref={(input) => { this.input4 = input; }} placeholder="发票校验码后6位" maxLength={6} onPressEnter={this.onincreaseTabindex4} />
                                            )}
                                        </FormItem>
                                    )}
                                </Col>
                            </Row>
                            <Row>
                                <FormItem {...formItemLayout} >
                                    {getFieldDecorator('draftFlag', {
                                        initialValue: data && !!data.draftState
                                    })(
                                        <Checkbox disabled={decodeState} onChange={this.onChange} >录入时勾选发票</Checkbox>
                                    )}
                                </FormItem>
                            </Row>
                            <Row>
                                <Col span={16} offset={8}>
                                    <FormItem >
                                        <Button disabled={decodeState} style={{ width: '100%' }} className="mr10" type="primary" onClick={this.handleSubmit} loading={this.state.loading}>
                                            确认保存
                                        </Button>


                                    </FormItem>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                    {
                        this.state.originFileUrl &&
                        <div style={{ display: "inline-block", width: '58%', marginTop: 20 }}>
                            <span style={{ color: '#7E8E9F' }} className="hand" onClick={this.onOriginFile}>文件: <Icon type="paper-clip" /> {originFileUrlName}</span>
                        </div>
                    }
                </Card>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/display/apps/AuthManage/AddRest/index.tsx